import { User } from "@/types";
import { GENDER } from '@/utils/store-util';
const SESSION_TOKEN_KEY = "apollo-token";
const SESSION_USER_KEY = "apollo-user";

export function setToken(token: string): void {
  if (sessionStorage) {
    sessionStorage.setItem(SESSION_TOKEN_KEY, token);
  }
}

export function setUser(userData: string): void {
  if (sessionStorage) {
    sessionStorage.setItem(SESSION_USER_KEY, userData);
  }
}

export function getToken(): string {
  let token = "";
  if (sessionStorage) {
    const _token = sessionStorage.getItem(SESSION_TOKEN_KEY);
    token = _token ? _token : token;
  }
  return token;
}

export function getUser(): User {
  let user = {} as User;
  if (sessionStorage) {
    const userData = sessionStorage.getItem(SESSION_USER_KEY);
    user = userData ? (JSON.parse(userData) as User) : ({} as User);
  }
  return user;
}

export function cleanSession() {
  if (sessionStorage) {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
    sessionStorage.removeItem(SESSION_USER_KEY);
  }
}

export function isValidEmail(email: string) {
  /* eslint-disable no-useless-escape */
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email && !re.test(email)) return "Email is invalid.";
  return true;
}

export function isValidPhone(phone: string){
  const re = /^(\+886)([0-9]{9})$/;
  if(phone && !re.test(phone)) return "請照+886xxxxxxxxx格式(886後面9位)";
  return true;
}

export function isValidBirthday(bday: string){
  const re = /^(\d{4})\-\d{2}\-(\d{2})$/;
  if(bday && !re.test(bday)) return "請照 1991-01-01 格式";
  return true;
}

export function formatValue(value) {
  if (value === "true" || value === true) {
    return "有";
  } else if (value === "false" || value === false) {
    return "無";
  }
  //sarcopenia
  switch(value){
    case "Sarcopenia":
      return "肌少症";
    case "Possible":
      return "疑似肌少症";
    case "Normal(Special)":
      return "低肌肉量";
    case "Normal":
      return "無肌少症";
  }
  return value;
}

export function formatMeasureAt(timestamp: number) {
  const now = new Date();
  const preTime = new Date(timestamp * 1000).getTime();
  const preLocaleTime = new Date(timestamp * 1000);
  const today = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  const todayTime = new Date(today).getTime();
  const oneDayTime = 1000 * 24 * 60 * 60;

  const yesterdayTime = new Date(todayTime - oneDayTime).getTime();

  const newTime = preLocaleTime.toLocaleString().substring(0, preLocaleTime.toLocaleString().length - 3);
  if (preTime >= todayTime) {
    return '今天 ' + newTime;
  }
  else if (preTime < todayTime && yesterdayTime <= preTime) {
    return '昨天 ' + newTime;
  }
  else {
    return newTime;
  }

}
export function maskname(name){
  const len = name.length;
  switch (len) {
    case 2:
      name = name.substring(0, 1) + "◯";
      break;
    case 3:
      name =
        name.substring(0, 1) +
        "◯" +
        name.substring(2, 3);
      break;
    case 4:
      name =
        name.substring(0, 1) +
        "◯◯" +
        name.substring(3, 4);
      break;
    default:
      name =
        name.substr(0, 3) +
        "◯".repeat(len - 6 > 0 ? len - 6 : 1) +
        name.substr(len - 3, 3);
      break;
    }
  return name;
}

export function extractInfo(data) {
  const re = /^[0-9][a-zA-Z]/;
  data['realName'] = data.name;
  data['realIid'] = data.iid;
  if(data.name!==""){
    const len = data.name.length;
    if(data.name.substring(0,2)==='民眾'){
      data.name = data.name.substring(0,3) + maskname(data.name.substring(3));
    }
    else if(data.name.substring(0,2)==='院內'){
      data.name = data.name.substring(0,5) + maskname(data.name.substring(5));
    }
    else if(!re.test(data.name) || len >= 10){
      data.name = maskname(data.name);
    }
  }
  if(data.iid.length==10){
    data.iid = data.iid.substring(0, 3) + "*****" + data.iid.substring(8, 10);
  }
  if(data.title){
    data.name = data.title + "-" + data.name;
    data.realName = data.title + "-" + data.realName;
  }

  data.gender = GENDER[data.gender];
  // if (data.age === null || data.age === undefined){
  //   if (data.birthday){
  //     const now = new Date(Date.now());
  //     data.age = now - 
  //   }
  // }

  return data;
}

export async function formatUserInfo(users) {
  //andy
  // console.log(users);
  // console.log(users.length);

  if(Array.isArray(users))
  {
    if (users.length >= 1) {
      for (let element of users) {
        if (element.user) {
          element.user = await extractInfo(element.user);
        } else {
          element = await extractInfo(element);
        }
      }
    }
  }
  else {
      users.user = await extractInfo(users.user)
  }
  // console.log(users);
  return users;
}

export function FloorValue(value){
  return Math.floor(Number.parseFloat(value));
}

export function Rounding(value, decimals){
  const r = Math.pow(10,decimals);
  const m = Number((Math.abs(value) * r).toPrecision(15));
  return Math.round(m) / r * Math.sign(value);
  // return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

export function RegexCheck(value: string, type: string): boolean {
  const monthregex = /^\*$|^([1-9]|1[0-2]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)((\-([1-9]|1[0-2]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?|(\,([1-9]|1[0-2]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))*)$/;

  const day_of_weekregex = /^\*$|^([0-6]|SUN|MON|TUE|WED|THU|FRI|SAT)((\-([0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))?|(\,([0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))*)$/;

  const dayregex = /^\*$|^([1-9]|([12][0-9])|3[01])((\-([1-9]|([12][0-9])|3[01]))?|(\,([1-9]|([12][0-9])|3[01]))*)$/;

  const hourregex = /^\*$|^([0-9]|1[0-9]|2[0-3])((\-([0-9]|1[0-9]|2[0-3]))?|(\,([0-9]|1[0-9]|2[0-3]))*)$/;

  const minuteregex = /^\*$|^([0-9]|([1-5][0-9]))((\-[0-9]|\-([1-5][0-9]))?|(\,([0-9]|([1-5][0-9])))*)$/;

  const daystepregex = /^\*\/([1-9]|([12][0-9])|3[01])$/;

  const hourstepregex = /^\*\/([1-9]|1[0-9]|2[0-3])$/;

  const minutestepregex = /^\*\/([1-9]|([1-5][0-9]))$/;
  switch(type){
    case "month":
      return monthregex.test(value);
    case "day_of_week":
      return day_of_weekregex.test(value);
    case "day":
      return dayregex.test(value) || daystepregex.test(value);
    case "hour":
      return hourregex.test(value) || hourstepregex.test(value);
    case "minute":
      return minuteregex.test(value) || minutestepregex.test(value);
    default:
      return false;
  }
}

export function masking(name:string, masktype = 'name'){
  const re = /^[0-9][a-zA-Z]/;
  if(masktype==='name'){
    if(name!==""){
      const len = name.length;
      if(name.substring(0,2)==='民眾'){
        return name.substring(0,3) + maskname(name.substring(3));
      }
      else if(name.substring(0,2)==='院內'){
        return name.substring(0,5) + maskname(name.substring(5));
      }
      else if(!re.test(name) || len >= 10){
        return maskname(name);
      }
    }
  }else if(masktype==='iid'){
    if(name.length==10){
      return name.substring(0, 3) + "*****" + name.substring(8, 10);
    }
  }
  return name;
}

export function has_value(item){
  return (item===null)
      ? false
      : (item===undefined)
      ? false
      : (item==="")
          ? false
          : true;
}